module.exports = __webpack_public_path__ + "img/4.bea26bd8.webp";